/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ApiUpdateExpenseSelectedColumnsRequest,
  BulkUpdateExpensesPayload,
  ExpenseCardTransactionAllowedActions,
  ExpenseExtDto,
  ExpenseReimbursementAllowedActions,
  ExpenseSearchAllowedActionsResponse,
  ExpenseSearchCountResponse,
  ExpenseSearchSummaryResponse,
  GetAllowedActionsPayload,
  GetIdsPayload,
  GetListPayload,
  GetSummaryBody,
  PagedResponseExpenseExtDto,
  RequestSplitAsyncParams,
  SplitAutomationResponseDto,
  SplitAutomationStatusResponseDto,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ExpensesController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags expenses-controller
   * @name UpdateExpenseSelectedColumns
   * @request PUT:/api/v1/expense/{expenseId}/selected-columns
   */
  updateExpenseSelectedColumns = (
    expenseId: string,
    data: ApiUpdateExpenseSelectedColumnsRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseExtDto, any>({
      path: `/v1/expense/${expenseId}/selected-columns`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static updateExpenseSelectedColumnsPath = '/v1/expense/${expenseId}/selected-columns'
  static updateExpenseSelectedColumnsMethod = 'PUT'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name RequestSplitAsync
   * @request POST:/api/v1/expense/{expenseId}/split-automation/request-split
   */
  requestSplitAsync = (
    { expenseId, ...query }: RequestSplitAsyncParams,
    params: RequestParams = {},
  ) =>
    this.http.request<SplitAutomationResponseDto, any>({
      path: `/v1/expense/${expenseId}/split-automation/request-split`,
      method: 'POST',
      query: query,
      format: 'json',
      ...params,
    })

  static requestSplitAsyncPath = '/v1/expense/${expenseId}/split-automation/request-split'
  static requestSplitAsyncMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetSummary
   * @request POST:/api/v1/expense/summary
   */
  getSummary = (data: GetSummaryBody, params: RequestParams = {}) =>
    this.http.request<ExpenseSearchSummaryResponse, any>({
      path: `/v1/expense/summary`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getSummaryPath = '/v1/expense/summary'
  static getSummaryMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetList
   * @request POST:/api/v1/expense/list
   */
  getList = (data: GetListPayload, params: RequestParams = {}) =>
    this.http.request<PagedResponseExpenseExtDto, any>({
      path: `/v1/expense/list`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getListPath = '/v1/expense/list'
  static getListMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetIds
   * @request POST:/api/v1/expense/ids
   */
  getIds = (data: GetIdsPayload, params: RequestParams = {}) =>
    this.http.request<string[], any>({
      path: `/v1/expense/ids`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getIdsPath = '/v1/expense/ids'
  static getIdsMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name BulkUpdateExpenses
   * @request POST:/api/v1/expense/bulk-update
   */
  bulkUpdateExpenses = (data: BulkUpdateExpensesPayload, params: RequestParams = {}) =>
    this.http.request<ExpenseExtDto[], any>({
      path: `/v1/expense/bulk-update`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static bulkUpdateExpensesPath = '/v1/expense/bulk-update'
  static bulkUpdateExpensesMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetAllowedActions
   * @request POST:/api/v1/expense/allowed-actions
   */
  getAllowedActions = (data: GetAllowedActionsPayload, params: RequestParams = {}) =>
    this.http.request<
      | ExpenseSearchAllowedActionsResponse
      | ExpenseCardTransactionAllowedActions
      | ExpenseReimbursementAllowedActions,
      any
    >({
      path: `/v1/expense/allowed-actions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static getAllowedActionsPath = '/v1/expense/allowed-actions'
  static getAllowedActionsMethod = 'POST'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetCount
   * @request GET:/api/v1/expense/{expenseType}/count
   */
  getCount = (
    expenseType:
      | 'CARD_TRANSACTION'
      | 'CARD_TRANSACTION_LINE'
      | 'INVOICE'
      | 'INVOICE_LINE'
      | 'REIMBURSEMENT'
      | 'MILEAGE_LINE'
      | 'PER_DIEM_LINE'
      | 'REIMBURSEMENT_INVOICE_LINE'
      | 'REIMBURSEMENT_INVOICE_LINE_SPLIT'
      | 'FX_FEE'
      | 'PAYMENT_FEE'
      | 'DEFERRED_COST_RELEASE_ITEM'
      | 'unknown_default_open_api',
    params: RequestParams = {},
  ) =>
    this.http.request<ExpenseSearchCountResponse, any>({
      path: `/v1/expense/${expenseType}/count`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getCountPath = '/v1/expense/${expenseType}/count'
  static getCountMethod = 'GET'
  /**
   * No description
   *
   * @tags expenses-controller
   * @name GetStatus
   * @request GET:/api/v1/expense/{expenseId}/split-automation/split-status/{requestId}
   */
  getStatus = (expenseId: string, requestId: string, params: RequestParams = {}) =>
    this.http.request<SplitAutomationStatusResponseDto, any>({
      path: `/v1/expense/${expenseId}/split-automation/split-status/${requestId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getStatusPath = '/v1/expense/${expenseId}/split-automation/split-status/${requestId}'
  static getStatusMethod = 'GET'
}
